import styled from "styled-components";

import { colorsPalettes, rgba, setElevation } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Stack } from "@similarweb/ui-components/foundations";

const { carbon, sky } = colorsPalettes;

export const Card = styled(Stack)`
    position: relative;
    align-items: center;
    gap: 20px;
    padding: 24px 0;
    background: ${sky[100]};
    border-radius: 8px;
    ${setElevation("Z2")}
`;

export const Header = styled(Stack)`
    align-items: center;
    gap: 8px;
`;

export const Illustration = styled.img`
    width: 340px;
    max-width: 100%;
    height: 246px;
`;

export const CloseButton = styled(IconButton)`
    position: absolute;
    top: 8px;
    right: 8px;
`;
